(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // ===== 搜索记忆 + 推荐 =====
(function() {
  const STORAGE_KEY = 'grabgo_recent_searches';
  const MAX_RECENT = 5;
  const input = document.getElementById('Search-Center-Input');
  const dropdown = document.getElementById('search-dropdown');
  const recentSection = document.getElementById('search-recent-section');
  const recentList = document.getElementById('search-recent-list');
  const suggestionsSection = document.getElementById('search-suggestions-section');
  const suggestionsList = document.getElementById('search-suggestions-list');

  if (!input) return;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; }
  }

  function saveRecent(term) {
    let recent = getRecent().filter(t => t !== term);
    recent.unshift(term);
    recent = recent.slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
  }

  function renderRecent() {
    const recent = getRecent();
    if (recent.length === 0) { recentSection.hidden = true; return; }
    recentSection.hidden = false;
    recentList.innerHTML = recent.map(term => `
      <li>
        <a href="/search?q=${encodeURIComponent(term)}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
          ${term}
        </a>
      </li>
    `).join('');
  }

  let debounceTimer;
  function fetchSuggestions(q) {
    clearTimeout(debounceTimer);
    if (!q || q.length < 2) { suggestionsSection.hidden = true; return; }
    debounceTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
        .then(r => r.json())
        .then(data => {
          const products = data.resources?.results?.products || [];
          if (products.length === 0) { suggestionsSection.hidden = true; return; }
          suggestionsSection.hidden = false;
          suggestionsList.innerHTML = products.map(p => `
            <li>
              <a href="${p.url}">
                ${p.image ? `<img class="search-dropdown__suggestion-img" src="${p.image}" alt="${p.title}">` : ''}
                <span>${p.title}</span>
              </a>
            </li>
          `).join('');
        }).catch(() => { suggestionsSection.hidden = true; });
    }, 200);
  }

  input.addEventListener('focus', () => {
    renderRecent();
    dropdown.hidden = false;
  });

  input.addEventListener('input', () => {
    fetchSuggestions(input.value.trim());
    renderRecent();
    dropdown.hidden = false;
  });

  document.addEventListener('click', (e) => {
    if (!document.getElementById('header-search-center').contains(e.target)) {
      dropdown.hidden = true;
    }
  });

  input.closest('form').addEventListener('submit', () => {
    const term = input.value.trim();
    if (term) saveRecent(term);
  });
})();
// ===== 手机端：把三杠移入icons =====
(function() {
  function moveMobileDrawer() {
    if (window.innerWidth >= 990) return;
    var drawer = document.querySelector('header-drawer');
    var icons = document.querySelector('.header__icons');
    if (drawer && icons && !icons.contains(drawer)) {
      icons.prepend(drawer);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveMobileDrawer);
  } else {
    moveMobileDrawer();
  }
  window.addEventListener('resize', moveMobileDrawer);
})();

  } catch(e) { console.error(e); }
})();
})();
